import { render, staticRenderFns } from "./ClockDetails.vue?vue&type=template&id=173974e2&scoped=true&"
import script from "./ClockDetails.vue?vue&type=script&lang=js&"
export * from "./ClockDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClockDetails.vue?vue&type=style&index=0&id=173974e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173974e2",
  null
  
)

export default component.exports